import Layout from '../layouts/Layout'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {Titulo} from "asocomponents"
import NuevoPagoSinFacturaContainer from '../../components/organismos/NuevoPagoSinFacturaContainer/NuevoPagoSinFacturaContainer'

function NuevoPagoSinFactura() {
  const navigate = useNavigate()
  const redireccionar=()=>navigate('/loguin')  

  //Valido si el usuario esta logueado sino se lo redirecciona al loguin
  useEffect(() => {
    const usuarioGuardado = sessionStorage.getItem('usuario')
    if (!usuarioGuardado) {
      redireccionar()
    }
  }, [])

  return (
    <Layout>
      <Titulo titulo="Nuevo Pago"/>
      <NuevoPagoSinFacturaContainer/>
    </Layout>
  )
}

export default NuevoPagoSinFactura